<template lang="pug">
  div
</template>
<script type="text/javascript">
import eventsBus from '@/components/shared/EventsBus'
import {Howl} from 'howler'

export default {
  mounted () {
    window.eventsBus = eventsBus
    eventsBus.$on(eventsBus.NEW_MESSAGE, (data = {}) => {
      if ((this.$store.getters['chat/userStatus'] === 'connected' && this.$store.getters['chat/soundNotification']) || data.test) {
        var audio = new Howl({src: ['static/sounds/newChatMessage.mp3']})
        audio.play()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// SoundManager.vue?37433e70